import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import red from '@material-ui/core/colors/red';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    input: red,
    accent: {
      ...blue
    },
    error: red,
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js